import { AlertModalTypeEnum, useAlertModal, useWindowDimensions } from '@equifinance/shared';
import { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { RoutingContextType } from '../../routes';

const APP_MIN_WIDTH = 1280;
const APP_MIN_HEIGHT = 750;

const ContentWrapper = styled.p`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.fontSize[2]};
`}`;

export function AppScreenSizeAlert() {
  const { setAlertModalProps, showAlertModal, closeAlertModal } = useAlertModal();
  const { width, height } = useWindowDimensions();
  const { canOpenScreenSizeAlert, setCanOpenScreenSizeAlert }: RoutingContextType = useOutletContext();

  useEffect(() => {
    if (canOpenScreenSizeAlert && (width < APP_MIN_WIDTH || height < APP_MIN_HEIGHT)) {
      setAlertModalProps({
        isOpen: true,
        hideClose: true,
        title: 'Screen Size',
        confirmLabel: '',
        cancelLabel: 'OK',
        type: AlertModalTypeEnum.WARNING_REVERSIBLE,
        content: (
          <ContentWrapper>
            {`Your screen size is below the minimum required ${APP_MIN_WIDTH} x ${APP_MIN_HEIGHT}. 
            Please increase your screen size or use an alternative device.`}
          </ContentWrapper>
        ),
        onClose() {
          setCanOpenScreenSizeAlert?.(false);
          closeAlertModal();
        },
      });
      showAlertModal();
    }
  }, [width, height]);

  useEffect(() => () => closeAlertModal(), []);
  return (<></>);
}
